var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ibox " }, [
    _c("div", { staticClass: "ibox-title" }, [
      _c("div", { staticClass: "ibox-tools" }, [
        _c(
          "span",
          { class: ["label float-right", _vm.declaration.tag.class] },
          [_vm._v(_vm._s(_vm.declaration.tag.title))]
        ),
      ]),
      _vm._v(" "),
      _c("h5", [_vm._v(_vm._s(_vm.declaration.title))]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "ibox-content" }, [
      _c("h1", { staticClass: "no-margins" }, [
        _vm._v(_vm._s(_vm.declaration.amount)),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "stat-percent font-bold text-success" }, [
        _vm._v(_vm._s(_vm.declaration.percent) + "% "),
        _c("i", { class: _vm.declaration.icon }),
      ]),
      _vm._v(" "),
      _c("small", [_vm._v(_vm._s(_vm.declaration.description))]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }